import React, { useState } from 'react'

import { Map } from 'immutable'
import { Field, reduxForm } from 'redux-form/immutable'

import DefaultButton from '@lyrahealth-inc/ui-core/lib/atoms/buttons/defaultButton/DefaultButton'
import TextArea from '@lyrahealth-inc/ui-core/lib/atoms/form/textArea/TextArea'
import { SelectFieldRFF } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/formElements/SelectField'

import { paymentExclusionReasons } from '../../../constants/appConstants'
import HiddenField from '../HiddenField'

const exclusionOptions = [
  ...Object.keys(paymentExclusionReasons).map((reason) => ({ label: reason, value: reason })),
  { label: 'Other', value: 'other' },
]

const ExcludePaymentForm: React.FC<ExcludePaymentFormProps> = ({
  initialValues,
  showExcludeText,
  submitting,
  submitFunction,
  handleSubmit,
}) => {
  const [exclusionReason, setExclusionReason] = useState(initialValues?.get('description') || '')
  const [exclusionReasonTextArea, setExclusionReasonTextArea] = useState(
    initialValues?.get('description_text_area') || '',
  )
  return (
    // @ts-expect-error TS(2322): Type 'void' is not assignable to type 'FormEventHa... Remove this comment to see the full error message
    <form onSubmit={handleSubmit(submitFunction)}>
      {showExcludeText && (
        <div>
          <h3>
            <strong>Exclude Session</strong>
          </h3>
          <p>Please describe the reason for excluding this session from this client’s session count</p>
        </div>
      )}
      <Field name='charge_id' type='hidden' component={HiddenField} />
      <Field
        name='description'
        // @ts-expect-error TS(2769): react-final-form's FieldRenderProps vs redux-form's WrappedFieldProps
        component={SelectFieldRFF}
        options={exclusionOptions}
        placeholder='Select'
        onChange={(_event: React.ChangeEvent<any>, value: string) => {
          if (value !== 'other' && exclusionReasonTextArea) {
            setExclusionReasonTextArea('')
          }
          setExclusionReason(value)
        }}
      />
      {exclusionReason === 'other' && (
        <Field
          name='description_text_area'
          component={TextArea}
          onChange={(e: any) => setExclusionReasonTextArea(e.target.value)}
          placeholder='Reason for excluding payment'
        />
      )}
      <DefaultButton
        id='requestexclude-submit'
        type='submit'
        isLoading={submitting}
        disabled={
          !(exclusionReason && exclusionReason !== 'other') && !(exclusionReason === 'other' && exclusionReasonTextArea)
        }
      >
        {showExcludeText ? 'Exclude Session' : 'Submit Comment'}
      </DefaultButton>
    </form>
  )
}

type ExcludePaymentFormProps = {
  initialValues: Map<string, any>
  showExcludeText: boolean
  submitting: boolean
  handleSubmit: (submitFunction: () => void) => void
  submitFunction: () => void
}

export default reduxForm({
  form: 'excludePaymentForm',
  touchOnBlur: false,
  enableReinitialize: true,
  // @ts-expect-error TS(2345): Argument of type 'FC<ExcludePaymentFormProps>' is ... Remove this comment to see the full error message
})(ExcludePaymentForm)
